import { useEffect, useRef, useState } from "react";

/**
 * Milliseconds elapsed since the screen entered the warming state, ticking once a second; 0 when
 * not warming. The start instant is kept across re-renders and reset when warming ends, so the
 * card can say how long the user has been waiting without the queries having to know.
 */
export function useWarmingClock(warming: boolean): number {
  const startedAt = useRef<number | null>(null);
  const [elapsedMs, setElapsedMs] = useState(0);

  useEffect(() => {
    if (!warming) {
      startedAt.current = null;
      setElapsedMs(0);
      return;
    }
    startedAt.current ??= Date.now();
    const tick = () => setElapsedMs(Date.now() - (startedAt.current ?? Date.now()));
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, [warming]);

  return elapsedMs;
}
